import Textfield from "../Input/Textfield";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Modal, { ModalProps } from "../Modal/Modal";
import { useModalMeta } from "@/shared/atoms/useModal";
import Button from "../Button/Button";
import useThemeHook from "@/shared/hooks/useThemeHook";

const ThemeCloneModal = ({ onExit, ...props }: ModalProps) => {
  const { t } = useTranslation();
  const [{ id, data: submitData }] = useModalMeta();
  const { postTheme } = useThemeHook();

  const { register, errors, handleSubmit } = useForm();

  const onSubmit = (data) => {
    postTheme
      .mutateAsync({
        ...submitData,
        template_name: data.name,
        product_id: id,
      })
      .then(() => {
        onExit();
      });
  };

  return (
    <Modal onExit={onExit} {...props}>
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
        <Textfield
          ref={register({
            required: {
              value: true,
              message: t("fieldRequired"),
            },
          })}
          error={errors.order_user?.house_number?.message}
          label={t("name")}
          name="name"
        />
        <Button type="submit" isPending={postTheme.isPending}>
          {t("save")}
        </Button>
      </form>
    </Modal>
  );
};

export default ThemeCloneModal;
